import React from 'react';
import {Accordion, AccordionActions, AccordionDetails, AccordionSummary, Grid} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FaiBox from "../../../MuiComponents/FaiBox";
import FaiTypography from "../../../MuiComponents/FaiTypography";
import theme from "../../../assets/theme";
import FaiSelect from "../../../MuiComponents/FaiSelect";
import OrderIssues from "./components/OrderIssues";
import PlatformIssues from "./components/PlatformIssues";


function RaiseTicket(props) {
    const {typography} = theme;
    return (
        <>
            <FaiBox mb={3}>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}

                    >
                        Order related issues
                    </AccordionSummary>
                    <AccordionDetails>
                        <OrderIssues/>
                    </AccordionDetails>
                </Accordion>
            </FaiBox>
            <FaiBox>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                    >
                        Platform related issues
                    </AccordionSummary>
                    <AccordionDetails>
                        <PlatformIssues/>
                    </AccordionDetails>
                </Accordion>
            </FaiBox>
        </>
    );
}

export default RaiseTicket;
